import $api from "@http";

export default class RequestService {
  static async sendReport(title, text) {
    return $api.post("/api/v1/bug_report", {
      title,
      text,
    });
  }

  static async userFeedback(steps) {
    return $api.post("/api/v1/suggestion_report", {
      steps,
    });
  }
}
